import React from "react";

function AboutPage() {
  return <div className="middle">About Page</div>;
}

export default AboutPage;
